<template>
  <div class="contentHome">
    <div class="centerPage">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadCrumb">
        <el-breadcrumb-item>
          <a href="javascript:void(0);" @click="$router.back()" class="aHref">医生列表</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>详情信息</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="formUserInfo">
        <el-form
            ref="data.authDoctor"
            class="info"
            :model="data"
            label-width="95px"
            label-suffix="：">
          <el-image style="width: 133px;height: 146px" :src="data.authDoctor.headImgPath" fit="cover"></el-image>
          <el-upload class="edit-head" name="uploadFile"
                     :action="updateHeadImgAction"
                     :limit="1"
                     :headers="updateHeadImgHeader"
                     :on-success="updateHeadImgSuccessHandle"
                     :show-file-list="false">
            <el-button size="small" type="primary">修改头像</el-button>
          </el-upload>
          <p class="tit">基本信息</p>
          <el-form-item label="真实姓名" prop="fullName">
            <el-input v-model="data.authDoctor.fullName" style="width: 400px;" maxlength="200"
                      placeholder="真实姓名"></el-input>
          </el-form-item>
          <el-form-item label="英文姓名" prop="enName">
            <el-input v-model="data.authDoctor.enName" style="width: 400px;" maxlength="200"
                      placeholder="英文名称"></el-input>
          </el-form-item>
          <el-form-item label="性别">
            <el-radio-group v-model="data.authDoctor.gender">
              <el-radio :label="1">男</el-radio>
              <el-radio :label="0">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="医生类型">
            <el-radio-group v-model="data.authDoctor.medicineType">
              <el-radio :label="1">咨询师</el-radio>
              <el-radio :label="2">医生</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="国家" prop="country">
            <el-input v-model="data.authDoctor.country" style="width: 400px;" maxlength="80"
                      placeholder="所在国家"></el-input>
          </el-form-item>
          <el-form-item label="所在省(州)" prop="abodeCity">
            <el-input v-model="data.authDoctor.abodeCity" style="width: 400px;" maxlength="80"
                      placeholder="所在省份(州)"></el-input>
          </el-form-item>
          <el-form-item label="所在城市" prop="province">
            <el-input v-model="data.authDoctor.province" style="width: 400px;" maxlength="80"
                      placeholder="所在城市"></el-input>
          </el-form-item>
          <el-form-item label="所在区" prop="district">
            <el-input v-model="data.authDoctor.district" style="width: 400px;" maxlength="80"
                      placeholder="所在地区"></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="mobile">
            <el-input type="tel" v-model="data.authDoctor.mobile " placeholder="手机号码"></el-input>
          </el-form-item>
          <el-form-item label="邮箱账号" prop="email">
            <el-input v-model="data.authDoctor.email " style="width: 400px;" maxlength="200"
                      placeholder="邮箱账号"></el-input>
          </el-form-item>
          <el-form-item label="专业专科" prop="skill">
            <el-input v-model="data.authDoctor.professional" maxlength="200" style="width: 800px;" placeholder="专业专科"
                      prop="skill"></el-input>
          </el-form-item>
          <el-form-item label="专业擅长" prop="skill">
            <el-input v-model="data.authDoctor.skill" maxlength="200" style="width: 800px;" placeholder="专业擅长"
                      prop="skill"></el-input>
          </el-form-item>
          <el-form-item label="从业时间">
            <el-date-picker type="date" v-model="data.authDoctor.startWorkDate" placeholder="从业时间"></el-date-picker>
          </el-form-item>
          <el-form-item label="签名" prop="signature">
            <el-input v-model="data.doctorSupplement.signature"
                      type="textarea"
                      :autosize="{ minRows: 4, maxRows: 5}"
                      maxlength="250"
                      style="width: 800px;"
                      placeholder="签名"></el-input>
          </el-form-item>
          <div class="flex underlyingD">
            <el-form-item label="医生网址">
              <span>{{ website }}{{ data.authDoctor.account }}</span>
            </el-form-item>
          </div>
          <div class="save-btn">
            <el-button type="primary" @click="saveBtnCallback(saveBaseInfo,'baseInfo',800)">保存</el-button>
          </div>
        </el-form>

        <el-form ref="data.authDoctor" class="info" :model="data.authDoctor" label-width="80px" label-suffix="：">
          <p class="tit">职业信息</p>
          <el-form-item label="所在单位" prop="company">
            <el-input v-model="data.authDoctor.company" style="width: 400px;" maxlength="250"
                      placeholder="所在单位"></el-input>
          </el-form-item>
          <el-form-item label="科室" prop="department">
            <el-input v-model="data.authDoctor.department" style="width: 400px;" maxlength="250"
                      placeholder="科室"></el-input>
          </el-form-item>
          <div class="flex underlyingD">
            <el-form-item label="职位" prop="job">
              <el-input v-model="data.authDoctor.job" style="width: 400px;" placeholder="职位" maxlength="250"></el-input>
            </el-form-item>
          </div>
          <div class="save-btn">
            <el-button type="primary" @click="saveBtnCallback(saveWorkInfo,'workInfo',800)">保存</el-button>
          </div>
        </el-form>

        <el-form ref="data.authDoctor1" class="info" :model="data.authDoctor" label-width="80px" label-suffix="：">
          <p class="tit">专业资质</p>
          <el-form-item label="资质认证" prop="certSource">
            <el-input v-model="data.doctorSupplement.certSource" style="width: 400px;" maxlength="250"
                      placeholder="资质认证"></el-input>
          </el-form-item>
          <el-form-item label="职称" prop="technicalTitle">
            <el-input v-model="data.authDoctor.technicalTitle" style="width: 400px;" maxlength="250"
                      placeholder="职称"></el-input>
          </el-form-item>
          <div class="flex underlyingD">
            <el-form-item label="教育背景" prop="eduBackground">
              <el-input v-model="data.doctorSupplement.eduBackground" maxlength="250" style="width: 400px;"
                        placeholder="教育背景"></el-input>
            </el-form-item>
          </div>

          <el-form-item label="资格证书" style="margin-top: 20px;">
            <el-form-item label="编号" style="margin-bottom: 8px;">
              <el-input v-model="data.authDoctor.licenceNo" maxlength="250"></el-input>
            </el-form-item>
            <el-form-item label="颁发时间" style="margin-bottom: 8px;">
              <el-date-picker v-model="data.authDoctor.licenceIssuedDate"></el-date-picker>
            </el-form-item>
            <el-form-item label="证件照">
<!--              <template v-if="data.authDoctor.licenceFilePath">-->
              <el-image
                  v-if="data.authDoctor.licenceFilePath"
                  style="width: 100px; height: 100px"
                  fit="cover"
                  :src="data.authDoctor.licenceFilePath" :preview-src-list="srcList"></el-image>
              <el-upload
                  :action="uploadUrl+'cert'"
                  name="uploadFile"
                  :show-file-list="false"
                  :on-success="handleLicenceSuccess">
                <el-button size="small" type="primary">
                  上传图片
                </el-button>
              </el-upload>
              <!--<div :style="'backgroundImage: url('+data.authDoctor.licenceFilePath+')'" style="width: 300px;height: 300px;background-size: 100% 100%"></div>-->
            </el-form-item>
          </el-form-item>

          <el-form-item label="执业证" style="margin-top: 20px;">
            <el-form-item label="编号" style="margin-bottom: 8px;">
              <el-input v-model="data.authDoctor.certNo" maxlength="250"></el-input>
            </el-form-item>
            <el-form-item label="颁发时间" style="margin-bottom: 8px;">
              <el-date-picker v-model="data.authDoctor.certIssuedDate"></el-date-picker>
            </el-form-item>
            <el-form-item label="证件照">
<!--              <el-image-->
<!--                  style="width: 100px; height: 100px"-->
<!--                  v-if="data.authDoctor.certFilePath"-->
<!--                  :src="data.authDoctor.certFilePath" :preview-src-list="srcList"></el-image>-->
<!--              <el-button v-else>没有图片,点击上传</el-button>-->

              <el-image
                  v-if="data.authDoctor.certFilePath"
                  style="width: 100px; height: 100px"
                  fit="cover"
                  :src="data.authDoctor.certFilePath" :preview-src-list="srcList"></el-image>
              <el-upload
                  :action="uploadUrl+'licence'"
                  name="uploadFile"
                  :show-file-list="false"
                  :on-success="handleCertSuccess">
                <el-button size="small" type="primary">
                  上传图片
                </el-button>
              </el-upload>
            </el-form-item>
          </el-form-item>
          <div class="save-btn">
            <el-button type="primary" @click="saveBtnCallback(saveMajorInfo,'majorInfo',800)">保存</el-button>
          </div>
        </el-form>

        <el-form ref="data.authDoctor" class="info" :model="data.authDoctor" label-width="80px" label-suffix="：">
          <p class="tit">账户信息</p>
          <el-form-item label="开户银行" prop="bankName">
            <el-input v-model="data.authDoctor.bankName" style="width: 400px;" maxlength="250"
                      placeholder="开户银行"></el-input>
          </el-form-item>
          <el-form-item label="开户名称" prop="bankAccountName">
            <el-input v-model="data.authDoctor.bankAccountName " style="width: 400px;" maxlength="250"
                      placeholder="开户名称"></el-input>
          </el-form-item>
          <div class="flex underlyingD">
            <el-form-item label="账户号码" prop="bankAccountNo">
              <el-input v-model="data.authDoctor.bankAccountNo " style="width: 400px;" maxlength="250"
                        placeholder="账户号码"></el-input>
            </el-form-item>
          </div>
          <div class="save-btn">
            <el-button type="primary" @click="saveBtnCallback(saveBankInfo,'bankInfo',800)">保存</el-button>
          </div>
        </el-form>

        <el-form ref="info" class="info">
          <p class="tit">荣誉成就</p>
          <div class="achievement">
            <el-form-item v-for="(item, index) in honors" :key="index" :prop="item">
              <el-input v-model="honors[index]" maxlength="200" style="width: 360px"></el-input>
              <a href="javascript:;" class="flex">
                <i class="el-icon-circle-close" @click="delHonorsItem(index)"></i>
              </a>
            </el-form-item>
          </div>
          <el-button size="small" style="border-color:#567BFF;color: #567BFF;" plain @click="addHonorInput">新增
          </el-button>
          <div class="save-btn">
            <el-button type="primary" @click="saveBtnCallback(saveHonorInfo,'honorInfo',800)">保存</el-button>
          </div>
        </el-form>

        <el-form ref="info" class="info" label-width="80px" label-suffix="：">
          <p class="tit">服务类型</p>
          <div class="serviceType">
            <el-checkbox-group v-model="indicationIds" class="handleCheckedChange" style="width: 95%;">
              <el-checkbox v-for="item in indicationAll" :key="item.id" :label="item.id">{{ item.cnName }}</el-checkbox>
            </el-checkbox-group>
            <span v-for="obj in indicationData" :key="obj.id">{{ obj.cnName }}</span>
            <div class="save-btn">
              <el-button type="primary" @click="saveBtnCallback(saveIndicationInfo,'indicationInfo',800)">保存</el-button>
            </div>
          </div>
        </el-form>

        <el-form ref="departTagForm" class="info" label-width="80px" label-suffix="：" :hide-required-asterisk="true"
                 @submit.native.prevent>
          <p class="tit">专业科室</p>

          <div class="flex" style="justify-content: space-between;">
            <div>
              <el-tag
                  v-for="(tag,index) in departTag.tags"
                  :key="tag" effect="dark"
                  :disable-transitions="false"
                  @close="handleRemoveTag(index,'departTag')"
                  closable>
                {{ tag }}
              </el-tag>
              <el-input
                  class="input-new-tag"
                  v-if="departTag.inputVisible"
                  v-model="departTag.inputValue"
                  ref="saveDepartTagInput"
                  size="small"
                  @keyup.enter.native="handleTagInputConfirm('departTag')"
                  @blur="handleTagInputConfirm('departTag')">
              </el-input>
              <el-button v-else size="small" class="button-new-tag" style="border-color:#567BFF;color: #567BFF;" plain
                         @click="showTagInput('departTag','saveDepartTagInput')">新增科室
              </el-button>
            </div>
            <div class="save-btn">
              <el-button type="primary" @click="saveBtnCallback(saveDepartTagForm,'departTagInfo',800)">保存</el-button>
            </div>
          </div>
        </el-form>
  
        <el-form ref="languageTagForm" class="info" label-width="80px" label-suffix="：" :hide-required-asterisk="true" @submit.native.prevent>
          <p class="tit">语言</p>
          <div class="flex" style="justify-content: space-between;">
            <div>
              <el-tag
                  v-for="(tag,index) in languageTag.tags"
                  :key="tag" effect="dark"
                  :disable-transitions="false"
                  @close="handleRemoveTag(index,'languageTag')"
                  closable>
                {{ tag }}
              </el-tag>
              <el-input
                  class="input-new-tag"
                  v-if="languageTag.inputVisible"
                  v-model="languageTag.inputValue"
                  ref="saveLanguageTagInput"
                  size="small"
                  @keyup.enter.native="handleTagInputConfirm('languageTag')"
                  @blur="handleTagInputConfirm('languageTag')">
              </el-input>
              <el-button v-else size="small" class="button-new-tag" style="border-color:#567BFF;color: #567BFF;" plain
                         @click="showTagInput('languageTag','saveLanguageTagInput')">新增语言
              </el-button>
            </div>
            <div class="save-btn">
              <el-button type="primary" @click="saveBtnCallback(saveLanguageTagForm,'languageTagInfo',800)">保存</el-button>
            </div>
          </div>
        </el-form>
        

        <el-form ref="info" class="info">
          <p class="tit">简述</p>
          <div class="underlyingD resume">
            <el-form-item prop="briefDesc">
              <el-input v-model="data.doctorSupplement.briefDesc" type="textarea" :autosize="{ minRows: 4, maxRows: 5}"
                        style="width: 800px;"
                        placeholder="简述"></el-input>
            </el-form-item>
          </div>
          <div class="save-btn">
            <el-button type="primary" @click="saveBtnCallback(saveBriefDescInfo,'briefDescInfo',800)">保存</el-button>
          </div>

        </el-form>

        <el-form ref="other" class="info">
          <p class="tit">其他</p>
          <el-form-item label="问诊次数">
            <el-input v-model="data.doctorSupplement.consultationCount" readonly></el-input>
          </el-form-item>
          <el-form-item label="被关注数">
            <el-input v-model="data.doctorSupplement.concernCount" readonly></el-input>
          </el-form-item>
          <el-form-item label="最后活跃时间">
            <el-input v-model="data.authDoctor.lastActiveDate" readonly></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="info"
                       @click="toArticle(data.authDoctor.fullName)">文章情况
            </el-button>
            <el-button type="info"
                       @click="toAppoint(data.authDoctor.fullName)">预约情况
            </el-button>
            <el-button type="info"
                       @click="toExam(data.authDoctor.fullName)">测试情况
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="success"
                       v-if="data.authDoctor.accountState===3"
                       @click="showUpdateStatus(data.authDoctor)">解封
            </el-button>
            <el-button type="danger"
                       v-else
                       @click="showUpdateStatus(data.authDoctor)">封禁
            </el-button>
            <el-button type="primary"
                       @click="showApprove(doctorId)"
                       v-if="data.authDoctor.accountState === 1">审核
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <el-dialog title="审核" width="500px" :visible.sync="approveDialog" :show-close="false"
               :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form v-loading="load" ref="form" :model="approve" label-width="80px" size="mini"
               style="padding-right: 20px;">
        <el-form-item label="审批结果">
          <el-radio-group v-model="approve.status">
            <el-radio label="2">通过</el-radio>
            <el-radio label="3">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="意见/原因">
          <el-input type="textarea" rows="5" v-model="approve.reason" placeholder="请输入意见/原因（拒绝时必填）"/>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="approve.remark"></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" @click="submit">确定</el-button>
          <el-button @click="closeApprove">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog :title="ban?'封禁':'解封'" width="500px" :visible.sync="banDialog" :show-close="false"
               :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="form" :model="banCondition" label-width="80px" size="mini"
               style="padding-right: 20px;">
        <el-form-item label="意见/原因">
          <el-input type="textarea" rows="5" v-model="banCondition.reason" placeholder="请输入意见/原因"/>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="banCondition.remark"></el-input>
        </el-form-item>

        <el-form-item style="text-align: right;">
          <el-button type="primary" @click="updateStatus">确定</el-button>
          <el-button @click="closeUpdateStatus">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
import commonjs from "../../../api/common";

export default {
  name: "doctorDetail",
  data() {
    return {
      data: {
        authDoctor: {
          licenceFilePath: '',
          certFilePath: ''
        },
        doctorSupplement: {},
      },
      indicationData: [],
      doctorId: this.$route.params.id,
      website: commonjs.web_url + "/",
      honors: [],
      srcList: [],

      approveDialog: false,
      load: false,
      approve: {
        id: '',
        status: '2',
        reason: '',
        remark: ''
      },

      banDialog: false,
      ban: true,
      banCondition: {
        eventId: '',//doctorId
        reason: '',//原因
        remark: '',
      },//重置密码原因数据
      article: true,

      indicationAll: [], //所有
      indicationIds: [], //选中

      saveBtnTimer: {
        baseInfo: 0,
        workInfo: 0,
        majorInfo: 0,
        bankInfo: 0,
        honorInfo: 0,
        indicationInfo: 0,
        briefDescInfo: 0,
        departTagInfo: 0,
        languageTagInfo: 0,
      },
      updateHeadImgAction: commonjs.basePath + 'auth/auth-doctor/admin/update/headImg/' + this.$route.params.id, //更改头像path
      updateHeadImgHeader: {
        Authorization: 'bearer ' + localStorage.access_token
      },
      departTag: { // 科室信息
        tags: [],
        inputVisible: false,
        inputValue: '',
      },
      languageTag:{ // 语言标签信息
        tags: [],
        inputVisible: false,
        inputValue: '',
      },

      uploadUrl: commonjs.uploadUrl,

    }
  },
  mounted() {
    let that = this;
    that.getData();

    // department tags
    that.$ajax.get(commonjs.basePath + 'auth/doctor-tags/admin/department/' + that.doctorId).then(res => {
      if (res.data.status === 'success') {
        if (res.data.list && res.data.list.length > 0) {
          $(res.data.list).each((i, o) => {
            that.departTag.tags.push(o.tagName);
          })
        }
      }
    }).catch(err => {
      console.error('department tags load fail: ' + err);
    })
    
    // language tags
    that.$ajax.get(commonjs.basePath + 'auth/doctor-tags/admin/language/' + that.doctorId).then(res=>{
      if(res.data.status === 'success'){
        if (res.data.list && res.data.list.length > 0) {
          $(res.data.list).each((i, o) => {
            that.languageTag.tags.push(o.tagName);
          })
        }
      }
    });
    
  },

  inject: ['reload'],
  methods: {
    getData() {
      let that = this;
      this.$ajax
          .get(commonjs.api.doctor.admin.detail.replace("{id}", this.doctorId))
          .then(function (res) {
            if (res.data.status === 'success') {
              that.data = res.data.data;
              that.srcList.push(that.data.authDoctor.licenceFilePath);
              that.srcList.push(that.data.authDoctor.certFilePath);
              if (res.data.data.doctorSupplement && res.data.data.doctorSupplement.honors) {
                that.honors.push(...JSON.parse(res.data.data.doctorSupplement.honors));
              }
            } else {
              // that.$router.back();
            }
          });

      // 服务类型
      this.$ajax.get(commonjs.api.indication.types.simple_all).then(res => {
        if (res.data.status === 'success') {
          this.indicationAll = res.data.list;
          that.$ajax.get(commonjs.api.doctor.indication.replace("{id}", that.doctorId)).then(function (res) {
            if (res.data.status === 'success') {
              $(res.data.list).each((i, o) => {
                that.indicationIds.push(o.id);
              })
            }
          })
        }
      });

    },
    showApprove(id) {
      this.approve.id = id;
      this.approveDialog = true;
    },
    submit() {
      if (this.approve.id) {
        if (this.approve.status === 3 && $.trim(this.approve.reason).length === 0) {
          this.$message.warning("拒绝时原因必填");
          return;
        }
        // let url = base.manager_api.article[this.active.type].approve;
        this.load = true;
        this.$ajax.post(commonjs.manager_api.approve.doctor, this.approve).then((res) => {
          this.load = false;
          if (res.data.status === 'success') {
            this.closeApprove();
            this.reload();
            this.$message.success(res.data.message);
          } else {
            this.$message.error(res.data.message);
          }
        }).catch((err) => {
          console.error(err);
          this.$message.error("无法完成操作");
          this.load = false;
        });
      }
    },
    closeApprove() {
      this.approve.id = '';
      this.approve.status = '2';
      this.approve.reason = '';
      this.approve.remark = '';
      this.approveDialog = false;
    },
    showUpdateStatus(item) {
      this.banCondition.eventId = item.id;
      this.ban = (item.accountState !== 3);
      this.banDialog = true;
    },
    closeUpdateStatus() {
      this.banCondition.eventId = '';
      this.banCondition.reason = '';
      this.banDialog = false;
    },
    updateStatus() {
      let vm = this;
      let url = commonjs.manager_api.doctor.ban;
      if (!this.ban) {
        url = commonjs.manager_api.doctor.unBan;
      }
      this.$ajax.post(url, this.banCondition)
          .then(function (res) {
            if (res.data.status === 'success') {
              vm.$message.success('操作成功');
              vm.closeUpdateStatus();
              vm.data.authDoctor.accountState = vm.ban ? 3 : 2;
            } else {
              vm.$message.error(res.data.message);
            }
          }).catch((err) => {
        console.error(err);
        vm.$message.error('操作失败')
      })
    },
    toArticle(name) {
      this.$router.push({path: '../../page/list', query: {name: name}})
    },
    toAppoint(name) {
      this.$router.push({path: '../../appoint/list', query: {name: name}})
    },
    toExam(name) {
      this.$router.push({path: '../../exam/history/list', query: {name: name}})
    },
    /**
     * callback
     * type : timer 类型, data中预定义
     * timeout内重复点击防重复
     * */
    saveBtnCallback(callback, type, timeout) {
      if (!type) {
        return
      }
      if (!timeout || timeout < 300) {
        timeout = 300
      } //间隔至少大于300
      if (this.saveBtnTimer[type]) {
        clearInterval(this.saveBtnTimer[type]);
      }
      this.saveBtnTimer[type] = setTimeout(() => {
        callback();
        this.saveBtnTimer[type] = 0;
      }, timeout)
    },
    ajaxSaveInfo(url, data) {
      this.$ajax.post(url, data).then(res => {
        if (res.data.status === 'success') {
          this.$message.success('保存成功');
        } else {
          this.$message.error(res.data.message)
        }
      }).catch(err => {
        console.error(err);
        this.$message.error("保存失败")
      })
    },
    updateHeadImgSuccessHandle(res, file) {
      if (res.status === 'success') {
        this.$message.success('修改成功');
        this.data.authDoctor.headImgPath = URL.createObjectURL(file.raw);
      } else {
        this.$message.error('修改失败')
      }
    },
    saveBaseInfo() {
      let url = commonjs.basePath + 'auth/auth-doctor/admin/update/baseInfo/' + this.doctorId;
      let data = {
        fullName: this.data.authDoctor.fullName,
        enName: this.data.authDoctor.enName,
        gender: this.data.authDoctor.gender,
        country: this.data.authDoctor.country,
        abodeCity: this.data.authDoctor.abodeCity,
        province: this.data.authDoctor.province,
        district: this.data.authDoctor.district,
        mobile: this.data.authDoctor.mobile,
        email: this.data.authDoctor.email,
        skill: this.data.authDoctor.skill,
        professional: this.data.authDoctor.professional,
        medicineType: this.data.authDoctor.medicineType,
        //startWorkDate: this.data.authDoctor.startWorkDate,
        supplement: {
          signature: this.data.doctorSupplement.signature
        }
      };
      // 时间处理
      if (this.data.authDoctor.startWorkDate) {
        data.startWorkDate = new Date(this.data.authDoctor.startWorkDate).Format("yyyy-MM-dd HH:mm:ss");
      }
      this.ajaxSaveInfo(url, data);
    },
    saveWorkInfo() {
      let url = commonjs.basePath + 'auth/auth-doctor/admin/update/job/' + this.doctorId;
      let data = {
        company: this.data.authDoctor.company,
        department: this.data.authDoctor.department,
        job: this.data.authDoctor.job
      }
      this.ajaxSaveInfo(url, data);
    },
    saveMajorInfo() {
      let url = commonjs.basePath + 'auth/auth-doctor/admin/update/major/' + this.doctorId;
      let data = {
        technicalTitle: this.data.authDoctor.technicalTitle,
        licenceNo: this.data.authDoctor.licenceNo,
        licenceFilePath: this.data.authDoctor.licenceFilePath,
        certNo: this.data.authDoctor.certNo,
        certFilePath: this.data.authDoctor.certFilePath,
        supplement: {
          certSource: this.data.doctorSupplement.certSource,
          eduBackground: this.data.doctorSupplement.eduBackground,
        }
      };
      if (this.data.authDoctor.licenceIssuedDate) {
        data.licenceIssuedDate = new Date(this.data.authDoctor.licenceIssuedDate).Format("yyyy-MM-dd HH:mm:ss");
      }
      if (this.data.authDoctor.certIssuedDate) {
        data.certIssuedDate = new Date(this.data.authDoctor.certIssuedDate).Format("yyyy-MM-dd HH:mm:ss");
      }
      this.ajaxSaveInfo(url, data);
    },
    saveBankInfo() {
      let url = commonjs.basePath + 'auth/auth-doctor/admin/update/bank/' + this.doctorId;
      let data = {
        bankName: this.data.authDoctor.bankName,
        bankAccountName: this.data.authDoctor.bankAccountName,
        bankAccountNo: this.data.authDoctor.bankAccountNo
      };
      this.ajaxSaveInfo(url, data);
    },
    addHonorInput() {
      this.honors.push("");
    },
    delHonorsItem(index) {
      this.$messageBox.confirm("确定要移除吗？", "提示", {type: "warning"}).then(() => {
        this.honors.splice(index, 1);
      }).catch(() => {
      })
    },
    saveHonorInfo() {
      let url = commonjs.basePath + 'auth/auth-doctor/admin/update/honors/' + this.doctorId;
      let arr = [];
      $(this.honors).each((i, o) => {
        if ($.trim(o).length > 0) {
          arr.push(o);
        }
      });
      let honors = JSON.stringify(arr);
      let data = {supplement: {honors}};
      this.ajaxSaveInfo(url, data);
    },
    saveIndicationInfo() {
      let url = commonjs.basePath + 'auth/auth-doctor/admin/update/indication/' + this.doctorId;
      let ids = [];
      $(this.indicationIds).each((i, o) => {
        if ($.trim(o).length > 0) {
          ids.push({id: o});
        }
      })
      let data = {indications: ids};
      this.ajaxSaveInfo(url, data);
    },
    saveBriefDescInfo() {
      let url = commonjs.basePath + 'auth/auth-doctor/admin/update/briefDesc/' + this.doctorId;
      let data = {supplement: {briefDesc: this.data.doctorSupplement.briefDesc}};
      this.ajaxSaveInfo(url, data);
    },
    handleRemoveTag(index,tag) {
      this[tag].tags.splice(index, 1);
    },
    showTagInput(tag,refName) {
      this[tag].inputVisible = true;
      this.$nextTick(() => {
        this.$refs[refName].$refs.input.focus();
      });
    },
    handleTagInputConfirm(tag) {
      let inputValue = this[tag].inputValue;
      if (inputValue) {
        this[tag].tags.push(inputValue);
      }
      this[tag].inputVisible = false;
      this[tag].inputValue = '';
    },
    saveDepartTagForm() {
      let that = this;
      if (that.departTag.tags.length == 0) {
        that.$message.warning('至少填写一个');
        return;
      }
      that.$ajax.post(commonjs.basePath + 'auth/doctor-tags/admin/department/update/' + that.doctorId, {
        tagNames: that.departTag.tags
      }).then(res => {
        if (res.data.status === 'success') {
          that.$message.success('保存成功');
        } else {
          that.$message.error(res.data.message)
        }
      }).catch(err => {
        console.error(err);
        that.$message.error('保存失败');
      })
    },
    saveLanguageTagForm(){
      let that = this;
      if (that.languageTag.tags.length == 0) {
        that.$message.warning('至少填写一个');
        return;
      }
      that.$ajax.post(commonjs.basePath + 'auth/doctor-tags/admin/language/update/' + that.doctorId, {
        tagNames: that.languageTag.tags
      }).then(res => {
        if (res.data.status === 'success') {
          that.$message.success('保存成功');
        } else {
          that.$message.error(res.data.message)
        }
      }).catch(err => {
        console.error(err);
        that.$message.error('保存失败');
      })
    },

    //执业证书上传成功
    handleCertSuccess(res, file) {
      this.data.authDoctor.certFilePath = res.message;
      this.srcList.push(this.data.authDoctor.certFilePath);
    },
    //资格证书上传成功
    handleLicenceSuccess(res, file) {
      this.data.authDoctor.licenceFilePath = res.message;
      this.srcList.push(this.data.authDoctor.licenceFilePath);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/personalCenter.scss";

.centerPage {
  display: block;
  width: auto;
  padding: 0;

  .formUserInfo ::v-deep {

    .el-form-item__content .el-input__inner[readonly="readonly"] {
      border: none;
      color: #303139;
    }

    .el-form-item__content .el-input__inner {
      color: #666666;
    }
  }

  ::v-deep .el-radio__input.is-disabled + span.el-radio__label {
    color: #303139;
  }

}

label.el-form-item__label:before {
  content: '';
}

.save-btn {
  text-align: right;

  button {
    padding: 0 20px;
    height: 30px;
    line-height: 30px;
  }
}

.edit-head {
  display: inline-block;
  margin-left: 20px;
  vertical-align: bottom;
}
</style>
<style>
.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

.tag-save-btn {
  color: #FFF;
  background-color: #409EFF;
  border-color: #409EFF;

  padding: 0 20px;
  height: 30px;
  line-height: 30px;
  width: 80px;
  border-radius: 2px;
}
</style>